// Splits a full patient name into first / middle / last: first word, last word, and
// everything between as the middle name.
export const parsePatientName = (fullName) => {
  const words = (fullName || '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return { firstName: '', middleName: '', lastName: '' };
  if (words.length === 1) return { firstName: words[0], middleName: '', lastName: '' };
  return {
    firstName: words[0],
    middleName: words.slice(1, -1).join(' '),
    lastName: words[words.length - 1],
  };
};

// The name parts an edit form starts with. Some records carry only the full patient_name
// (Chrome-extension uploads, for one), so when the stored first or last name is missing the
// parts come from splitting the full name; a stored part survives where the split has none.
export const namePartsForEditing = ({
  firstName, middleName, lastName, fullName,
}) => {
  const stored = { firstName: firstName || '', middleName: middleName || '', lastName: lastName || '' };
  if ((stored.firstName && stored.lastName) || !(fullName || '').trim()) return stored;

  const parsed = parsePatientName(fullName);
  return {
    firstName: parsed.firstName,
    middleName: parsed.middleName || stored.middleName,
    lastName: parsed.lastName || stored.lastName,
  };
};
